<template>
    <div style="margin-top: 10px;padding: 16px;background-color: #fff;border-radius: 6px;">
        <a-tabs :activeKey="activeKey" @change="onTabChange">
            <a-tab-pane tab="我接收的" key="1"> </a-tab-pane>
            <a-tab-pane tab="我分享的" key="2"> </a-tab-pane>
        </a-tabs>

        <div class="container-block">
            <a-form-model layout="inline">
                <a-form-model-item label="产品">
                    <a-input style="width:200px" placeholder="输入产品名称或配方代码" @pressEnter="getList"
                        v-model="search.productKeyword" />
                </a-form-model-item>
                <a-form-model-item v-if="activeKey == 1" label="分享人">
                    <a-select show-search allow-clear :value="search.staffId" placeholder="输入分享人姓名" style="width: 200px"
                        :filter-option="false" @search="onStaffSearchDebounce" @change="onStaffChange">
                        <a-spin v-if="staffFetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="staff in staffList" :key="staff.id">
                            {{ staff.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item v-if="activeKey == 2" label="接收人">
                    <a-select show-search allow-clear :value="search.staffId" placeholder="输入接收人姓名" style="width: 200px"
                        :filter-option="false" @search="onStaffSearchDebounce" @change="onStaffChange">
                        <a-spin v-if="staffFetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="staff in staffList" :key="staff.id">
                            {{ staff.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="工厂">
                    <a-select show-search allow-clear :value="search.factoryId" placeholder="输入工厂名称"
                        style="width: 200px" :filter-option="false" @search="onFactorySearchDebounce"
                        @change="onFactoryChange">
                        <a-spin v-if="factoryFetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="factory in factoryList" :key="factory.id">
                            {{ factory.name }}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="日期">
                    <a-range-picker style="width: 300px" valueFormat="YYYY-MM-DD" v-model="search.shareDate" />
                </a-form-model-item>
                <a-form-model-item>
                    <a-space>
                        <a-button type="primary" @click="getList">查询</a-button>
                        <a-button @click="resetList">重置</a-button>
                    </a-space>
                </a-form-model-item>
            </a-form-model>
        </div>
        <a-table bordered :columns="tableColumns" :loading="tableLoading" :data-source="list.records"
            :row-key="record => record.id" :pagination="pagination">
            <a-space slot="options" slot-scope="text,record">
                <template v-if="activeKey == 1">
                    <a-button type="link" @click="viewDetail(record)">查看</a-button>
                    <a-button type="link" @click="deleteShare(record)">删除</a-button>
                </template>
                <template v-else>
                    <a-button type="link" @click="cancelShare(record)">取消分享</a-button>
                </template>
            </a-space>
        </a-table>
    </div>
</template>

<script>
import _ from "lodash";
export default {
    name: 'ShareManagement',
    data() {
        return {
            activeKey: '1',

            factoryId: undefined,
            factoryList: [],
            factoryFetching: false,
            onFactorySearchDebounce: null,
            staffId: undefined,
            staffList: [],
            staffFetching: false,
            onStaffSearchDebounce: null,
            search: {
                productKeyword: undefined,
                shareDate: [],
                factoryId: undefined,
                staffId: undefined
            },
            pagination: {
                total: 0,
                current: 1,
                pageSize: 20,
                showSizeChanger: true,
                showTotal: (total) => `共${total}条记录`,
                onChange: (current) => {
                    this.pagination.current = current;
                    this.getList();
                }, //选择页数
                onShowSizeChange: (current, pageSize) => {
                    this.pagination.pageSize = pageSize;
                    this.pagination.current = 1;
                    this.getList();
                }, //每页多少条
            },
            list: {
                records: [],
            },
            tableLoading: false,
            tableColumns: [
                {
                    title: '日期',
                    dataIndex: 'shareDatetime',
                    align: 'center',
                    width: 200
                },
                {
                    title: '工厂名称',
                    dataIndex: 'factoryName',
                    align: 'center'
                },
                {
                    title: '分享人',
                    dataIndex: 'shareStaffName',
                    align: 'center'
                },
                {
                    title: '产品名称',
                    dataIndex: 'productName',
                    align: 'center'
                },
                {
                    title: '配方代码',
                    dataIndex: 'formulaCode',
                    align: 'center'
                },
                {
                    title: '版本',
                    dataIndex: 'version',
                    align: 'center'
                },
                {
                    title: '操作',
                    dataIndex: 'options',
                    align: 'center',
                    width: 150,
                    scopedSlots: { customRender: 'options' }
                }
            ]
        };
    },
    created() {
        this.onFactorySearchDebounce = _.debounce(this.onFactorySearch, 600);
        this.onStaffSearchDebounce = _.debounce(this.onStaffSearch, 600);
        this.getList();
    },
    methods: {
        onTabChange(key) {
            this.activeKey = key;
            if (key == 1) {
                this.tableColumns.splice(1, 2, {
                    title: '工厂名称',
                    dataIndex: 'factoryName',
                    align: 'center'
                }, {
                    title: '分享人',
                    dataIndex: 'shareStaffName',
                    align: 'center'
                });
            }
            if (key == 2) {
                this.tableColumns.splice(1, 2, {
                    title: '工厂名称',
                    dataIndex: 'receiveFactoryName',
                    align: 'center'
                }, {
                    title: '接收人',
                    dataIndex: 'receiveStaffName',
                    align: 'center'
                });
            }
            this.search.staffId = undefined;
            this.search.factoryId = undefined;
            this.search.productKeyword = undefined;
            this.search.shareDate = [];
            this.list.records = [];
            this.pagination.current = 1;
            this.getList();
        },
        async onFactorySearch(value) {
            this.factoryFetching = true;
            const res = await this.$get("/iot-factory/factory/selectFactoryInfoPage", { size: 1000, current: 1, name: value });
            if (res.data && res.data?.records) {
                this.factoryList = res.data.records;
            }
            this.factoryFetching = false;
        },
        onFactoryChange(value) {
            this.search.factoryId = value;
        },
        async onStaffSearch(value) {
            this.staffFetching = true;
            const res = await this.$post("/iot-user/userShortInfoListPage", { query: { size: 1000, current: 1, }, name: value });
            if (res.data && res.data?.records) {
                this.staffList = res.data.records;
            }
            this.staffFetching = false;
        },
        onStaffChange(value) {
            this.search.staffId = value;
        },
        getList() {
            const postData = {
                query: {
                    current: this.pagination.current,
                    size: this.pagination.pageSize,
                },
                productKeyword: this.search.productKeyword,
            };
            if (this.search.shareDate.length > 0) {
                postData.shareTimeStart = this.search.shareDate[0] + ' 00:00:00';
                postData.shareTimeEnd = this.search.shareDate[1] + ' 23:59:59';
            }
            if (this.activeKey == 1) {
                postData.factoryId = this.search.factoryId;
                postData.receiveFactoryId = window.localStorage.getItem('factoryId');
                postData.shareStaffId = this.search.staffId;
                postData.receiveStaffId = JSON.parse(window.localStorage.getItem('userInfo'))?.userId;
            }
            if (this.activeKey == 2) {
                postData.factoryId = window.localStorage.getItem('factoryId');
                postData.receiveFactoryId = this.search.factoryId;
                postData.receiveStaffId = this.search.staffId;
                postData.shareStaffId = JSON.parse(window.localStorage.getItem('userInfo'))?.userId;
            }

            this.tableLoading = true;
            this.$post('/nhf-app/productshare/pageProductShareDTO', postData).then(res => {
                if (res.success) {
                    let { current = 1, total = 0, size = 10 } = res.data;
                    this.list = res.data;
                    this.pagination.current = current;
                    this.pagination.pageSize = size;
                    this.pagination.total = total;
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        resetList() {
            this.search.staffId = undefined;
            this.search.factoryId = undefined;
            this.search.productKeyword = undefined;
            this.search.shareDate = [];
            this.list.records = [];
            this.pagination.current = 1;
            this.getList();
        },
        viewDetail(record) {
            this.$router.push({
                path: '/shareManagement/shareManagementList/share-product-detail',
                query: {
                    name: '产品详情',
                    id: record.id,
                    productId: record.productId
                }
            });
        },
        cancelShare(record) {
            this.$confirm({
                title: '提示',
                content: '确定取消您分享给他人的产品配方吗？',
              cancelText: '取消',
              okText: '确定',
              onOk: () => {
                    this.$http.post('/nhf-app/productshare/delProductShare', { idList: [record.id] }).then(res => {
                        if (res.success) {
                            this.$message.success('取消成功');
                            this.getList();
                        }
                    });
                }
            });
        },
        deleteShare(record) {
            this.$confirm({
                title: '提示',
                content: '确定删除来自他人分享的产品配方吗？',
                cancelText: '取消',
                okText: '确定',
                onOk: () => {
                    this.$http.post('/nhf-app/productshare/delProductShare', { idList: [record.id] }).then(res => {
                        if (res.success) {
                            this.$message.success('删除成功');
                            this.getList();
                        }
                    });
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped></style>
